import { View } from "@/models/view";
import { HumanFilter } from "@/utils/human-filter";

export interface IPaginationData {
	limit: number;
	offset: number;
	orderBy: string;
	orderDirection: "ASC" | "DESC";
}

interface IOptionalQueryParams {
	dontSaveViewSettings?:boolean;
	extraPreloads?:string[]
	additionalPreloads?:string[];
}

export interface IQueryParamsWithOptionalView extends IQueryFilters, IPaginationData, IOptionalQueryParams{
	view?:View;
}

export interface IQueryParams extends IQueryFilters, IPaginationData, IOptionalQueryParams{
	view: View;
}

export interface IQueryFilters {
	filters: HumanFilter[];
	searchQuery?: string;
	searchByAllColumns?: boolean;
	autoWildCardSearch?: boolean;
}


export function getEmptyIQueryParams():IQueryParams{
	return {
		limit: 10,
		offset: 0,
		orderBy: "ID",
		orderDirection: "ASC",
		view: new View(),
		filters: []
	};
}

export function getEmptyIQueryFilters():IQueryFilters{
	return {
		filters: [],
		searchQuery: "",
		searchByAllColumns: false,
		autoWildCardSearch: false,
	};
}
